export const removePath = (url: string): string => {
    const queryStringIndex = url.indexOf('?')
    return queryStringIndex !== -1 ? url?.substring(queryStringIndex) : ''
}
